// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (-webkit-min-device-pixel-ratio:0){input[data-v-818e741c],select[data-v-818e741c],textarea[data-v-818e741c]{font-size:16px}}@font-face{font-display:swap;font-family:oneplusSans;src:local(\"Pacifico Regular\"),local(\"Pacifico-Regular\"),url(/fonts/OnePlusSansDisplay-55Rg.ttf)}.v-application[data-v-818e741c]{background-color:#f3f6f9}.custom_fc_frame[data-v-818e741c]{bottom:130px!important;right:50px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
